const jobListing = function () {

    $('.jobListShowPopupButton').on('click', function (e) {
        e.preventDefault();

        var pop = new Esearcher.Popup(this.getAttribute('href'), 'Aktion');

        pop.show();
    });
};

export default jobListing;
